import {
  isNotNull,
  isNull
} from "./chunk-NQ7GJGRO.js";

// src/utils/DateMethods.ts
import { isDate, isString } from "lodash";
import { DateTime, Settings } from "luxon";
Settings.defaultZone = "America/Sao_Paulo";
Settings.defaultLocale = "pt-BR";
var dt = DateTime;
function createDateTime(date) {
  const { fromFormat, fromJSDate, fromISO } = dt;
  let dateTime = null;
  if (!date) return dateTime;
  if (isDate(date) && fromJSDate(date).isValid) {
    dateTime = fromJSDate(date).toUTC();
  }
  if (isString(date) && fromFormat(date, "dd/MM/yyyy").isValid) {
    dateTime = fromFormat(date, "dd/MM/yyyy").toUTC();
  }
  if (isString(date) && fromISO(date).isValid) {
    dateTime = fromISO(date).toUTC();
  }
  return dateTime;
}
function isValidDate(date) {
  const { fromFormat, fromJSDate, fromISO } = dt;
  let result = false;
  if (isDate(date)) {
    result = fromJSDate(date).isValid;
  }
  if (isString(date)) {
    result = fromFormat(date, "dd/MM/yyyy").isValid || fromISO(date).isValid;
  }
  return result;
}
function formatToBrazilianDate(date) {
  try {
    const dateTime = createDateTime(date);
    return isNotNull(dateTime) ? dateTime.toLocaleString() : "";
  } catch (err) {
    console.error("ERROR:FORMAT_TO_BR_DATE:", err);
    return "";
  }
}
function formatToISODate(date) {
  try {
    if (!date) return "";
    const dateTime = createDateTime(date);
    return isNotNull(dateTime) ? dateTime.toISODate() ?? "" : "";
  } catch (err) {
    console.error("ERROR:FORMAT_TO_ISO_DATE:", err);
    return "";
  }
}
function isToday(date) {
  try {
    const today = dt.now();
    const dateTime = createDateTime(date);
    return isNotNull(dateTime) ? today.toISODate() === dateTime.toISODate() : false;
  } catch (err) {
    console.error("ERROR:IS_TODAY:", err);
  }
}
function isDateGreaterThan(date, compareDate) {
  try {
    if (!isValidDate(date) || !isValidDate(compareDate)) return false;
    const dateTime = createDateTime(date);
    const compareDateTime = createDateTime(compareDate);
    if (isNull(dateTime) || isNull(compareDateTime)) {
      throw new Error("Invalid date");
    }
    return dateTime > compareDateTime;
  } catch (err) {
    console.error("ERROR:IS_DATE_GRATER_THAN:", err);
  }
}
function isDateLessThan(date, compareDate) {
  try {
    if (!isValidDate(date) || !isValidDate(compareDate)) return false;
    const dateTime = createDateTime(date);
    const compareDateTime = createDateTime(compareDate);
    if (isNull(dateTime) || isNull(compareDateTime)) {
      throw new Error("Invalid date");
    }
    return dateTime < compareDateTime;
  } catch (err) {
    console.error("ERROR:IS_DATE_MINOR_THAN:", err);
  }
}
function isSameDate(date, compareDate) {
  try {
    if (!isValidDate(date) || !isValidDate(compareDate)) return false;
    const dateTime = createDateTime(date);
    const compareDateTime = createDateTime(compareDate);
    if (isNull(dateTime) || isNull(compareDateTime)) {
      throw new Error("Invalid date");
    }
    return dateTime.toISODate() === compareDateTime.toISODate();
  } catch (err) {
    console.error("ERROR:IS_SAME_DATE:", err);
  }
}
function getCurrentYear() {
  return dt.now().year;
}
export {
  createDateTime,
  formatToBrazilianDate,
  formatToISODate,
  getCurrentYear,
  isDateGreaterThan,
  isDateLessThan,
  isSameDate,
  isToday,
  isValidDate
};
//# sourceMappingURL=date.js.map